// ¿HAY UNA VERSIÓN NUEVA DE LA APP DEL MÓVIL? — LA COMPARACIÓN Y EL «AHORA NO» (6-oct-2026)
//
// Lo usa components/AvisoActualizarApp.jsx, que solo pregunta dentro de la app nativa (Capacitor). Aquí no hay React ni
// servidor: son las reglas, para que una guardia las pueda ejecutar tal cual (backend/routes/apps-aviso-version-tienda).
//
// LAS VERSIONES SON NÚMEROS SEPARADOS POR PUNTOS Y SE COMPARAN PARTE A PARTE: «1.10» es MAYOR que «1.9» (como texto
// saldría al revés) y una parte que falta cuenta como 0 («1.0» = «1.0.0» < «1.0.1»). Lo que no es una versión (vacío, con
// letras, «1..2») no se compara: no se avisa. La misma regla está en backend/services/appsTienda.js.
import { t } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

const RE_VERSION = /^\d{1,6}(?:\.\d{1,6}){0,3}$/

export const TIENDA = Object.freeze({ get ios() { return t('utils.versionTienda.app_store', 'App Store') }, get android() { return t('utils.versionTienda.google_play', 'Google Play') } })
// Cómo se dice «en su tienda» en una frase: «en Google Play», «en la App Store».
export const EN_TIENDA = Object.freeze({ get ios() { return t('utils.versionTienda.en_la_app_store', 'en la App Store') }, get android() { return t('utils.versionTienda.en_google_play', 'en Google Play') } })
// Solo la ficha de la tienda de verdad: es lo que hace que «Actualizar» salga de la app (Capacitor abre FUERA de la app
// cualquier dirección que no sea biango.app) y lleve a la tienda que toca.
const HOSTS = Object.freeze({ ios: ['apps.apple.com'], android: ['play.google.com'] })

export function limpiarVersion(v) {
  if (v == null) return null
  const s = String(v).trim()
  return RE_VERSION.test(s) ? s : null
}

// -1, 0 o 1; null si alguna de las dos no es una versión.
export function compararVersiones(a, b) {
  const x = limpiarVersion(a)
  const y = limpiarVersion(b)
  if (x === null || y === null) return null
  const pa = x.split('.').map((n) => parseInt(n, 10))
  const pb = y.split('.').map((n) => parseInt(n, 10))
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0)
    if (d !== 0) return d < 0 ? -1 : 1
  }
  return 0
}

// El enlace a la ficha, solo si es https y de la tienda de esa plataforma. Si no, null.
export function enlaceDeTienda(plataforma, url) {
  if (!HOSTS[plataforma] || typeof url !== 'string' || !url.trim()) return null
  let u
  try { u = new URL(url.trim()) } catch (_) { return null }
  if (u.protocol !== 'https:' || u.username || u.password || u.port) return null
  return HOSTS[plataforma].includes(u.hostname.toLowerCase()) ? u.href : null
}

// QUÉ AVISO TOCA. Entra lo instalado (la versión de App.getInfo y la plataforma) y lo que contesta /api/apps-tienda.
// Sale null (nada que decir) o { obligatorio, instalada, publicada, enlace, tienda, enTienda }. Obligatorio = por debajo de la
// mínima (y la mínima no pasa de la publicada): entonces el aviso no se puede cerrar.
export function decidirAviso({ instalada, plataforma, publicada, minima, enlace } = {}) {
  if (!TIENDA[plataforma]) return null
  const tengo = limpiarVersion(instalada)
  const hay = limpiarVersion(publicada)
  if (!tengo || !hay) return null
  const ir = enlaceDeTienda(plataforma, enlace)
  if (!ir) return null
  if (compararVersiones(tengo, hay) >= 0) return null
  const min = limpiarVersion(minima)
  const obligatorio = !!min && compararVersiones(min, hay) <= 0 && compararVersiones(tengo, min) < 0
  return { obligatorio, instalada: tengo, publicada: hay, enlace: ir, tienda: TIENDA[plataforma], enTienda: EN_TIENDA[plataforma] }
}

// ── «AHORA NO»: HASTA EL DÍA SIGUIENTE, Y SOLO PARA ESA VERSIÓN ───────────────────────────────────
// Se apunta en este móvil el día (el del propio móvil) y la versión publicada que se ha dejado para luego. Al día
// siguiente vuelve a salir; y si mientras tanto se publica otra más nueva, sale en el momento. El obligatorio no se pospone.
export const CLAVE_AHORA_NO = 'biango_app_actualizar_ahora_no'

export function diaLocal(fecha) {
  const d = fecha instanceof Date ? fecha : new Date()
  const dos = (n) => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + dos(d.getMonth() + 1) + '-' + dos(d.getDate())
}

export function leerAhoraNo(almacen) {
  try {
    const s = almacen && typeof almacen.getItem === 'function' ? almacen.getItem(CLAVE_AHORA_NO) : null
    const v = s ? JSON.parse(s) : null
    return v && typeof v === 'object' ? v : null
  } catch (_) { return null }
}

export function guardarAhoraNo(almacen, { app, publicada, dia } = {}) {
  try {
    if (!almacen || typeof almacen.setItem !== 'function') return false
    almacen.setItem(CLAVE_AHORA_NO, JSON.stringify({ app: String(app || ''), publicada: String(publicada || ''), dia: String(dia || diaLocal()) }))
    return true
  } catch (_) { return false }
}

// ¿Lo dejó para luego HOY, para ESTA app y ESTA versión?
export function pospuestoHoy(guardado, { app, publicada, hoy } = {}) {
  if (!guardado || typeof guardado !== 'object') return false
  return guardado.app === app && guardado.publicada === publicada && guardado.dia === (hoy || diaLocal())
}
